export const GET_FOOD_LIST = 'GET_Food_LIST';
export const GET_SEARCH_LIST = 'GET_Search_LIST';
export const GET_DETAIL_DATA = 'GET_DETAIL_DATA';
export const CLEAN_FOOD_LIST = 'Clean_FOOD_LIST';
export const UPDATE_VOTENUMBER = 'UPDATE_VOTENUMBER';
